"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var launchdarkly_react_client_sdk_1 = require("launchdarkly-react-client-sdk");
var convert_user_to_ld_user_1 = __importDefault(require("./convert-user-to-ld-user"));
function useClient() {
    var ldClient = (0, launchdarkly_react_client_sdk_1.useLDClient)();
    var identifyUser = function (user, hash, callback) {
        if (ldClient) {
            var ldUser = "anonymous" in user ? user : (0, convert_user_to_ld_user_1["default"])(user);
            ldClient.identify(ldUser, hash, callback);
        }
    };
    return {
        identifyUser: identifyUser,
        on: function (eventName, listener) { return ldClient === null || ldClient === void 0 ? void 0 : ldClient.on(eventName, listener); },
        off: function (eventName, listener) { return ldClient === null || ldClient === void 0 ? void 0 : ldClient.on(eventName, listener); }
    };
}
exports["default"] = useClient;
//# sourceMappingURL=useClient.js.map